import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconWeight from '@src/assets/images/common/icon/editor/SvgIconWeight';
import type { Editor } from '@tiptap/react';
import React from 'react';

interface BoldButtonProps {
  editor: Editor;
  isActive: boolean;
  refreshActiveState: () => void;
}

export const BoldButton: React.FC<BoldButtonProps> = ({ editor, isActive, refreshActiveState }) => {
  const activeHoverColor = brandColors['500'] || '#2B5CDD';
  const defaultIconColor = 'currentColor';

  return (
    <button
      onClick={() => {
        editor.view.dom.focus({ preventScroll: true });
        editor.chain().toggleBold().run();
        refreshActiveState();
      }}
      className={`toolbar-button ${isActive ? 'active' : ''}`}
      title='太字'
      type='button'
    >
      <SvgIconWeight color={isActive ? activeHoverColor : defaultIconColor} />
    </button>
  );
};
